import { useGetExamCourseAnalysisReportQuery } from '@report/graphql';
import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { ORDER_TYPE } from '@shared/graphql';
import { useDisclosure } from '@shared/hooks';
import { dayjs } from '@shared/utils';

import { MONTH_ORDER } from '../../constants';
import { useExamCourseAnalysisReportSearchParams } from '../../hooks';
import { ExamCourseAnalysisReportExportModal } from '../exam-course-analysis-report-export-modal';

export default function ExamCourseAnalysisReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  const handleClick = () => {
    openModal();
  };

  const [
    {
      startMonth,
      startYear,
      endMonth,
      endYear,
      examCenter,
      examCourse,
      courseType,
      sortOrder,
      qConfigRef,
    },
  ] = useExamCourseAnalysisReportSearchParams();

  const isSearchEmpty =
    !startMonth ||
    !endMonth ||
    !startYear ||
    !endYear ||
    !examCourse.length ||
    !examCenter.length ||
    !courseType.length ||
    !qConfigRef.length;

  const { data: examCourseAnalysisReportData, loading: isLoading } =
    useGetExamCourseAnalysisReportQuery({
      variables: {
        getExamCourseAnalysisReportInput: {
          filter: {
            startedAt: dayjs()
              .set(
                'month',
                MONTH_ORDER.findIndex((month) => month === startMonth),
              )
              .set('year', startYear)
              .startOf('month')
              .toDate(),
            endedAt: dayjs()
              .set(
                'month',
                MONTH_ORDER.findIndex((month) => month === endMonth),
              )
              .set('year', endYear)
              .endOf('month')
              .toDate(),
            examCenterCodes: examCenter.includes('all') ? null : examCenter,
            examCourseCodes: examCourse.includes('all') ? null : examCourse,
            qConfigRefs: qConfigRef.includes('all') ? null : qConfigRef.map((ref) => Number(ref)),
            examCourseTypes: courseType,
          },
          order: {
            type: sortOrder ? ORDER_TYPE[sortOrder] : ORDER_TYPE.asc,
            field: 'examId',
          },
        },
      },
      skip: isSearchEmpty,
      fetchPolicy: 'cache-first',
    });

  const totalRows =
    examCourseAnalysisReportData?.reportGetExamCourseAnalysisReport.examCourseAnalysisReports
      .length ?? 0;

  const shouldDisable = totalRows === 0 || isLoading;

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <ExamCourseAnalysisReportExportModal
        open={isModalOpen}
        onClose={closeModal}
        total={totalRows}
      />
    </>
  );
}
